import createReducer from '../../utils/createReducer';
import {
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_ERROR,
  GET_STATES_SUCCESS,
  GET_STATES_ERROR,
  CLIENT_STATES_ERROR,
  CLIENT_STATES,
  CLIENT_STATES_SUCCESS,
  CLIENT_COUNTRIES,
  CLIENT_COUNTRIES_ERROR,
  CLIENT_COUNTRIES_SUCCESS,
} from '../../actions/common/commonConstants';

const initialState = {
  countries: [],
  states: [],
  clientStates: [],
  clientCountries: [],
  error: '',
};

export default createReducer(
  {
    [GET_COUNTRIES_SUCCESS]: getCountries,
    [GET_COUNTRIES_ERROR]: getCountriesError,
    [GET_STATES_SUCCESS]: getStates,
    [GET_STATES_ERROR]: getStatesError,
    [CLIENT_STATES]: startFetchingClientStates,
    [CLIENT_STATES_SUCCESS]: getClientStatesSuccess,
    [CLIENT_STATES_ERROR]: getClientStatesError,
    [CLIENT_COUNTRIES]: startFetchingClientCountries,
    [CLIENT_COUNTRIES_SUCCESS]: getClientCountriesSuccess,
    [CLIENT_COUNTRIES_ERROR]: getClientCountriesError,
  },
  initialState,
);

function getCountries(state, { payload }) {
  return {
    ...state,
    countries: payload,
    error: '',
  };
}

function getCountriesError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function getStates(state, { payload }) {
  return {
    ...state,
    states: payload,
    error: '',
  };
}

function getStatesError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function startFetchingClientStates(state) {
  return {
    ...state,
    loading: true,
    error: '',
  };
}
function getClientStatesSuccess(state, { payload }) {
  return {
    ...state,
    clientStates: payload,
    error: '',
    loading: false,
  };
}

function getClientStatesError(state, { payload }) {
  return {
    ...state,
    error: payload,
    loading: false,
  };
}

function startFetchingClientCountries(state) {
  return {
    ...state,
    loading: true,
    error: '',
  };
}
function getClientCountriesSuccess(state, { payload }) {
  return {
    ...state,
    clientCountries: payload,
    error: '',
    loading: false,
  };
}

function getClientCountriesError(state, { payload }) {
  return {
    ...state,
    error: payload,
    loading: false,
  };
}
